import type { CrmPeriodDetails } from "@/hooks/api/useAdminViews";

import { Card, CardContent } from "@/components/ui/card";
import { Hint } from "@/components/ui/hint";
import { Tag } from "lucide-react";

/** Also the hover on the fallback table in dashboard.tsx. */
export const DISCOUNT_SOURCE =
  "Fakturaer med discount_used, trukket i perioden, på abonnement opprettet i perioden med status active eller stopped. Antall = fakturaer per kode. Rabatter på fornyelser av eldre abonnement er ikke med.";

export function DiscountTable({ discountDetails }: { discountDetails: CrmPeriodDetails["discountDetails"] }) {
  if (discountDetails.length === 0) {
    return (
      <Card>
        <CardContent className="p-4 text-sm text-admin-text-subtle">Ingen rabattkoder brukt i perioden</CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardContent className="p-0">
        <div className="px-4 pt-4 pb-2 flex items-center gap-2">
          <Tag className="h-4 w-4 text-admin-primary" />
          <Hint
            className="text-sm font-medium text-admin-text-primary"
            text={DISCOUNT_SOURCE}
          >
            Rabattkoder
          </Hint>
          <span className="text-xs text-admin-text-subtle">({discountDetails.length} koder)</span>
        </div>
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-admin-card-border">
              <th className="text-left text-xs font-medium text-admin-text-subtle px-4 py-2">Kode</th>
              <th className="text-right text-xs font-medium text-admin-text-subtle px-4 py-2">Antall</th>
            </tr>
          </thead>
          <tbody>
            {discountDetails.map((d) => (
              <tr key={d.code} className="border-b border-admin-card-border last:border-0">
                <td className="px-4 py-2 font-mono text-admin-text-primary">{d.code}</td>
                <td className="px-4 py-2 text-right text-admin-text-secondary">{d.count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </CardContent>
    </Card>
  );
}
